import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">焦点专题</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {carouselData.map((item, index) => (
            <div
              key={item.id}
              className={`group relative rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer ${
                index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative w-full ${index === 0 ? 'aspect-[16/10] lg:aspect-auto lg:h-full' : 'aspect-[4/3]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={index > 0 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              </div>
              <div className={`absolute bottom-0 left-0 right-0 p-5 ${index === 0 ? 'lg:p-7' : ''}`}>
                <span className="inline-block px-2.5 py-1 text-[11px] font-medium bg-accent-500 text-white rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className={`font-heading text-white mb-1 ${index === 0 ? 'text-xl lg:text-2xl' : 'text-base'}`}>
                  {item.title}
                </h3>
                <p className={`text-white/80 ${index === 0 ? 'text-sm' : 'text-xs'} line-clamp-2`}>
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}